// Set up all Venues with appropriate variables including Disploay name, city, website URL and blob url
export const venues = [
  {
    code: "BLOOM",
    name: "Bloomsbury",
    city: "london",
    url: "flightclubdarts.com",
    blob_url: "https://flightclubdarts.blob.core.windows.net",
    azure_url: "https://storiesvideos-ukso1.streaming.media.azure.net",
    video_url: "https://storiesvideostorage.blob.core.windows.net",
    feedback_url: "https://bit.ly/3DtHvR3",
    google_url: "https://g.page/r/CYeKYJJ9MKz_EAI/review",
  },
  {
    code: "BIRMI",
    name: "Birmingham",
    city: "birmingham",
    url: "flightclubdarts.com",
    blob_url: "https://flightclubdarts.blob.core.windows.net",
    azure_url: "https://storiesvideos-ukso1.streaming.media.azure.net",
    video_url: "https://storiesvideostorage.blob.core.windows.net",
    feedback_url: "https://bit.ly/3P7w9ov",
    google_url: "https://g.page/r/CfMIWoAthrLJEAI/review",
  },
  {
    code: "ISLIN",
    name: "Islington",
    city: "london",
    url: "flightclubdarts.com",
    blob_url: "https://flightclubdarts.blob.core.windows.net",
    azure_url: "https://storiesvideos-ukso1.streaming.media.azure.net",
    video_url: "https://storiesvideostorage.blob.core.windows.net",
    feedback_url: "https://bit.ly/4iIj82h",
    google_url: "https://g.page/r/CWJbim9XZntaEAI/review",
  },
  {
    code: "MANCH",
    name: "Manchester",
    city: "manchester",
    url: "flightclubdarts.com",
    blob_url: "https://flightclubdarts.blob.core.windows.net",
    azure_url: "https://storiesvideos-ukso1.streaming.media.azure.net",
    video_url: "https://storiesvideostorage.blob.core.windows.net",
    feedback_url: "https://bit.ly/41IEhmM",
    google_url: "https://g.page/r/CZSc7Do8-FEOEAI/review",
  },
  {
    code: "SHORE",
    name: "Shoreditch",
    city: "london",
    url: "flightclubdarts.com",
    blob_url: "https://flightclubdarts.blob.core.windows.net",
    azure_url: "https://storiesvideos-ukso1.streaming.media.azure.net",
    video_url: "https://storiesvideostorage.blob.core.windows.net",
    feedback_url: "https://bit.ly/41HR5d7",
    google_url: "https://g.page/r/Ca96En1gXUDBEAI/review",
  },
  {
    code: "VICTO",
    name: "Victoria",
    city: "london",
    url: "flightclubdarts.com",
    blob_url: "https://flightclubdarts.blob.core.windows.net",
    azure_url: "https://storiesvideos-ukso1.streaming.media.azure.net",
    video_url: "https://storiesvideostorage.blob.core.windows.net",
    feedback_url: "https://bit.ly/4iN3YZr",
    google_url: "https://g.page/r/Cf153N69nRUSEAI/review",
  },
  {
    code: "LEEDS",
    name: "Leeds",
    city: "leeds",
    url: "flightclubdarts.com",
    blob_url: "https://flightclubdarts.blob.core.windows.net",
    azure_url: "https://storiesvideos-ukso1.streaming.media.azure.net",
    video_url: "https://storiesvideostorage.blob.core.windows.net",
    feedback_url: "https://bit.ly/3VSfw3O",
    google_url: "https://g.page/r/CeDx3ZUGABE2EAI/review",
  },
  {
    code: "BRIST",
    name: "Bristol",
    city: "bristol",
    url: "flightclubdarts.com",
    blob_url: "https://flightclubdarts.blob.core.windows.net",
    azure_url: "https://storiesvideos-ukso1.streaming.media.azure.net",
    video_url: "https://storiesvideostorage.blob.core.windows.net",
    feedback_url: "https://bit.ly/49OalYv",
    google_url: "https://g.page/r/CeA7ShFo7wVQEAI/review",
  },
  {
    code: "CHELT",
    name: "Cheltenham",
    city: "cheltenham",
    url: "flightclubdarts.com",
    blob_url: "https://flightclubdarts.blob.core.windows.net",
    azure_url: "https://storiesvideos-ukso1.streaming.media.azure.net",
    video_url: "https://storiesvideostorage.blob.core.windows.net",
    feedback_url: "https://bit.ly/4gQLp50",
    google_url: "https://g.page/r/Cc0Zn0eBQSmWEAI/review",
  },
  {
    code: "CARDI",
    name: "Cardiff",
    city: "cardiff",
    url: "flightclubdarts.com",
    blob_url: "https://flightclubdarts.blob.core.windows.net",
    azure_url: "https://storiesvideos-ukso1.streaming.media.azure.net",
    video_url: "https://storiesvideostorage.blob.core.windows.net",
    feedback_url: "https://bit.ly/3DsqiYl",
    google_url: "https://g.page/r/Ca4GIjNXntslEAI/review",
  },
  {
    code: "GLASG",
    name: "Glasgow",
    city: "glasgow",
    url: "flightclubdarts.com",
    blob_url: "https://flightclubdarts.blob.core.windows.net",
    azure_url: "https://storiesvideos-ukso1.streaming.media.azure.net",
    video_url: "https://storiesvideostorage.blob.core.windows.net",
    feedback_url: "https://bit.ly/49PHPpm",
    google_url: "https://g.page/r/CenDf7GMGJ84EAI/review",
  },
  {
    code: "EDINB",
    name: "Edinburgh",
    city: "edinburgh",
    url: "flightclubdarts.com",
    blob_url: "https://flightclubdarts.blob.core.windows.net",
    azure_url: "https://storiesvideos-ukso1.streaming.media.azure.net",
    video_url: "https://storiesvideostorage.blob.core.windows.net",
    feedback_url: "https://bit.ly/4fvZzav",
    google_url: "https://g.page/r/CVZtlT4zOhu9EAI/review",
  },
  {
    code: "LIVER",
    name: "Liverpool",
    city: "liverpool",
    url: "flightclubdarts.com",
    blob_url: "https://flightclubdarts.blob.core.windows.net",
    azure_url: "https://storiesvideos-ukso1.streaming.media.azure.net",
    video_url: "https://storiesvideostorage.blob.core.windows.net",
    feedback_url: "https://bit.ly/41MJqdm",
    google_url: "https://g.page/r/CWG61953ohd2EAI/review",
  },
  {
    code: "OXFOR",
    name: "Oxford",
    city: "oxford",
    url: "flightclubdarts.com",
    blob_url: "https://flightclubdarts.blob.core.windows.net",
    azure_url: "https://storiesvideos-ukso1.streaming.media.azure.net",
    video_url: "https://storiesvideostorage.blob.core.windows.net",
    feedback_url: "https://bit.ly/41NDn8t",
    google_url: "https://g.page/r/CX7AwBqzsxlCEAI/review",
  },
  {
    code: "NEWCA",
    name: "Newcastle",
    city: "newscastle",
    url: "flightclubdarts.com",
    blob_url: "https://flightclubdarts.blob.core.windows.net",
    azure_url: "https://storiesvideos-ukso1.streaming.media.azure.net",
    video_url: "https://storiesvideostorage.blob.core.windows.net",
    feedback_url: "https://flightclubfeedback.hgem.com/?BranchCode=newca&VisitSource=Reservation",
    google_url: "https://g.page/r/CT-5JXrhuNkVEAI/review",
  },
  {
    code: "READI",
    name: "Reading",
    city: "reading",
    url: "flightclubdarts.com",
    blob_url: "https://flightclubdarts.blob.core.windows.net",
    azure_url: "https://storiesvideos-ukso1.streaming.media.azure.net",
    video_url: "https://storiesvideostorage.blob.core.windows.net",
    feedback_url: "https://flightclubfeedback.hgem.com/?BranchCode=readi&VisitSource=Reservation",
    google_url: "https://g.page/r/CRNh8UzB5tGvEAE/review",
  },
  {
    code: "BOSTO",
    name: "Boston",
    city: "boston",
    url: "https://flightclubdartsusa.com/boston/seaport",
    blob_url: "https://flightclubdartsusa.blob.core.windows.net",
    azure_url: "https://storiesvideosus-usso.streaming.media.azure.net",
    video_url: "",
    feedback_url: "https://g.page/r/CUeXtkyvsyNhEBM/review",
  },
  {
    code: "CHICA",
    name: "Chicago",
    city: "chicago",
    url: "flightclubdartsusa.com/chicago/wacker",
    blob_url: "https://flightclubdartsusa.blob.core.windows.net",
    azure_url: "https://storiesvideosus-usso.streaming.media.azure.net",
    video_url: "",
    feedback_url: "https://g.page/r/CbJJgIqLqxJcEBM/review",
  },
  {
    code: "HOUST",
    name: "Houston",
    city: "houston",
    url: "flightclubdartsusa.com/houston/regent-square",
    blob_url: "https://flightclubdartsusa.blob.core.windows.net",
    azure_url: "https://storiesvideosus-usso.streaming.media.azure.net",
    video_url: "",
    feedback_url: "https://g.page/r/CQfLfyKpa_cxEBM/review",
  },
  {
    code: "LASVE",
    name: "LasVegas",
    city: "lasvegas",
    url: "flightclubdartsusa.com/las-vegas/the-strip",
    blob_url: "https://flightclubdartsusa.blob.core.windows.net",
    azure_url: "https://storiesvideosus-usso.streaming.media.azure.net",
    video_url: "",
    feedback_url: "https://g.page/r/CYYyULVGpuZ0EBM/review",
  },
  {
    code: "ATLAN",
    name: "Atlanta",
    city: "atlanta",
    url: "flightclubdartsusa.com/atlanta/atlanta",
    blob_url: "https://flightclubdartsusa.blob.core.windows.net",
    azure_url: "https://storiesvideosus-usso.streaming.media.azure.net",
    feedback_url: "https://g.page/r/CYWwAV9OgmtLEBM/review",
  },
  {
    code: "CINCI",
    name: "Cincinnati",
    city: "cincinnati",
    url: "flightclubdartsusa.com/cincinnati/cincinnati",
    blob_url: "https://flightclubdartsusa.blob.core.windows.net",
    azure_url: "https://storiesvideosus-usso.streaming.media.azure.net",
    feedback_url: "",
  },
  {
    code: "PERTH",
    name: "Perth",
    city: "perth",
    url: "flightclubdarts.com.au",
    blob_url: "https://flightclubdartsaus.blob.core.windows.net",
    azure_url: "https://storiesvideosaus-aueas.streaming.media.azure.net",
    video_url: "https://videostorageaus.blob.core.windows.net",
    feedback_url: "http://tvrv.io/XF1Q8",
  },
  {
    code: "FREMA",
    name: "Fremantle",
    city: "Fremantle",
    url: "flightclubdarts.com.au",
    blob_url: "https://flightclubdartsaus.blob.core.windows.net",
    azure_url: "https://storiesvideosaus-aueas.streaming.media.azure.net",
    video_url: "https://videostorageaus.blob.core.windows.net",
    feedback_url: "http://tvrv.io/sZ0tJ",
  },
  {
    code: "SYDNE",
    name: "Sydney",
    city: "Sydney",
    url: "flightclubdarts.com.au",

    blob_url: "https://flightclubdartsaus.blob.core.windows.net",
    azure_url: "https://storiesvideosaus-aueas.streaming.media.azure.net",
    video_url: "https://videostorageaus.blob.core.windows.net",
    feedback_url: "http://tvrv.io/Qzues",
  },
  {
    code: "MELBO",
    name: "Melbourne",
    city: "Melbourne",
    url: "flightclubdarts.com.au",
    blob_url: "https://flightclubdartsaus.blob.core.windows.net",
    azure_url: "https://storiesvideosaus-aueas.streaming.media.azure.net",
    video_url: "https://videostorageaus.blob.core.windows.net",
    feedback_url: "http://tvrv.io/2rsqV",
  },
  {
    code: "NEWTO",
    name: "Newtown",
    city: "Newtown",
    url: "flightclubdarts.com.au",
    blob_url: "https://flightclubdartsaus.blob.core.windows.net",
    azure_url: "https://storiesvideosaus-aueas.streaming.media.azure.net",
    video_url: "https://videostorageaus.blob.core.windows.net",
    feedback_url: "https://review.tablevibe.co/?token=i7jhnYr5KkB4jbY9xLV1ywZC",
  },
  {
    code: "DENVE",
    name: "Denver",
    city: "denver",
    url: "flightclubdartsusa.com/denver/denver",
    blob_url: "https://flightclubdartsusa.blob.core.windows.net",
    azure_url: "https://storiesvideosus-usso.streaming.media.azure.net",
    feedback_url: "https://g.page/r/CUCOqGLKmOtyEBM/review",
  },
  {
    code: "WASHI",
    name: "Washington",
    city: "washington",
    url: "flightclubdartsusa.com/washington/dc",
    blob_url: "https://flightclubdartsusa.blob.core.windows.net",
    azure_url: "https://storiesvideosus-usso.streaming.media.azure.net",
    feedback_url: "",
  },
  {
    code: "STLOU",
    name: "StLouis",
    city: "stlouis",
    url: "flightclubdartsusa.com/st-louis/st-louis",
    blob_url: "https://flightclubdartsusa.blob.core.windows.net",
    azure_url: "https://storiesvideosus-usso.streaming.media.azure.net",
    feedback_url: "",
  },
  {
    code: "PHILA",
    name: "Philadelphia",
    city: "philadelphia",
    url: "flightclubdartsusa.com/philadelphia/philadelphia",
    blob_url: "https://flightclubdartsusa.blob.core.windows.net",
    azure_url: "https://storiesvideosus-usso.streaming.media.azure.net",
    feedback_url: "",
  },
  {
    code: "SEATT",
    name: "Seattle",
    city: "seattle",
    url: "flightclubdartsusa.com/seattle/seattle",
    blob_url: "https://flightclubdartsusa.blob.core.windows.net",
    azure_url: "https://storiesvideosus-usso.streaming.media.azure.net",
    feedback_url: "",
  },
  {
    code: "DUBLI",
    name: "Dublin",
    city: "dublin",
    url: "flightclubdarts.com/ie",
    blob_url: "https://flightclubdartsirl.blob.core.windows.net",
    azure_url: "",
    video_url: "https://videostorageirl.blob.core.windows.net",
    feedback_url: "https://share.google/WR3RMvHl12puaL4ah",
  },
];

// function to get Venue array based on story data venue code
export const getVenueName = (venue_code) => {
  let venue = {};
  venues.forEach((item) => {
    if (venue_code.length && venue_code.slice(0, 5).toUpperCase() == item.code) {
      venue = {
        venue_code: item.code,
        venue_name: item.name,
        city_name: item.city,
        city_url: item.url,
        blob_url: item.blob_url,
        azure_url: item.azure_url,
        video_url: item.video_url,
        feedback_url: item.feedback_url,
        google_url: item.google_url,
      };
    }
  });
  return venue;
};
